/* eslint-disable camelcase */
import loadable from '@loadable/component';
import keywordLandingPageQuery from './query.graphql';

const KeywordLandingPage = loadable(() =>
  import(/* webpackChunkName: "keyword-landing-page" */ './components/index')
);

/**
 * @param {string|undefined} variant
 */
function getProductNumberByVariant(variant) {
  if (!variant || variant === 'baseline') return 100;
  return parseInt(variant.substring('items'.length), 10);
}

export const queryToVariables = vars => {
  const { slug, query } = vars;

  return {
    slug,
    query,
    // set offset to 0 since we're not using pagination (yet)
    offset: 0,
    limit: getProductNumberByVariant(
      vars.experiments['kwlp-limit-products']?.selectedVariant
    ),
  };
};

KeywordLandingPage.variables = queryToVariables;

KeywordLandingPage.graphQL = keywordLandingPageQuery;

export default KeywordLandingPage;
